import React from 'react';
import Reveal from './Reveal';
import { stats } from '../data/site';

const Stats = () => (
  <section className="section" style={{ paddingTop: 0 }}>
    <div className="container">
      <Reveal className="stats-band">
        {stats.map((stat) => (
          <div key={stat.label} className="stat">
            <strong>{stat.value}</strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </Reveal>
    </div>
  </section>
);

export default Stats;
